<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table id="ni-portfolio-management-table">
      <thead>
        <tr>
          <th>Line No.</th>
          <th class="select-checkbox-cell">
            <b-checkbox
              ref="selectAllChecked"
              v-model="selectAllChecked"
              type="is-info"
              size="is-large"
            ></b-checkbox>
          </th>
          <th
            v-for="columnData in portfolioManagementColumns"
            :key="columnData.id"
            :title="columnData.title"
          >
            <label :class="columnData.className">{{ columnData.label }}</label>
          </th>
        </tr>
      </thead>
      <tbody class="ni-app-portfolio-management-tbody">
        <tr
          v-for="(portfolioManagementRow, index) in portfolioManagementRows"
          :key="portfolioManagementRow.id"
          :class="[
            portfolioManagementRow.pmQstnId
              ? 'portfolioManagementRow-' + portfolioManagementRow.pmQstnId
              : 'newRow',
            portfolioManagementRow.rejectedBy === 'CAS' &&
            (portfolioManagementRow.apprvlStatus === 'R' ||
              portfolioManagementRow.indStatus === 'Rejected')
              ? 'lock-row'
              : '',
            portfolioManagementRow.rejectedBy === loginNetworkId &&
            (portfolioManagementRow.apprvlStatus === 'R' ||
              portfolioManagementRow.indStatus === 'Rejected')
              ? 'lock-partial-row'
              : '',
            portfolioManagementRow.rejectedBy !== loginNetworkId &&
            portfolioManagementRow.rejectedByRole > 2 &&
            (portfolioManagementRow.apprvlStatus === 'R' ||
              portfolioManagementRow.indStatus === 'Rejected')
              ? 'lock-row'
              : '',
            portfolioManagementRow.rejectedBy !== loginNetworkId &&
            loginRole === 2 &&
            portfolioManagementRow.rejectedByRole === 1 &&
            (portfolioManagementRow.apprvlStatus === 'R' ||
              portfolioManagementRow.indStatus === 'Rejected')
              ? 'lock-partial-row'
              : '',
            psToRework &&
            portfolioManagementRow.rejectedBy !== loginNetworkId &&
            (portfolioManagementRow.apprvlStatus === 'R' ||
              portfolioManagementRow.indStatus === 'Rejected')
              ? 'lock-row'
              : ''
          ]"
          @click="onRowClick($event)"
          @change="
            !isLoading
              ? changeOnPortfolioManagementRow(
                  $event,
                  index,
                  portfolioManagementRow,
                  portfolioManagementColumns
                )
              : ''
          "
          v-bind="portfolioManagementRow"
        >
          <ValidationObserver>
            <td class="line-number item-checkbox">
              {{ portfolioManagementRow.lineNumber }}
            </td>
            <td style="display:none;">
              <b-input :value="portfolioManagementRow.pmQstnId"></b-input>
            </td>
            <td class="select-checkbox-cell item-checkbox">
              <b-checkbox
                type="is-info"
                size="is-large"
                v-model="checkboxGroup"
                :native-value="portfolioManagementRow.genlQstnId"
              ></b-checkbox>
            </td>
            <td class="line-errors item-checkbox">
              {{ portfolioManagementRow.lineErrors }}
            </td>
            <td>
              <b-input
                type="text"
                class="vcat"
                :value="portfolioManagementRow.vcat"
                disabled
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="desc"
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ./\\\\-]/g, '');"
                :value="portfolioManagementRow.desc30"
                disabled
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="max:30"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="pmDesc pmDesc30"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'pmDesc30',
                        portfolioManagementRow.pmDesc30
                      )
                    "
                    :value="portfolioManagementRow.pmDesc30"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ./\\\\-]/g, '');"
                    @change.native="
                      portfolioManagementRow.pmDesc30 = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                  <b-tooltip
                    label="Item Description - 30 Characters(Internal) length is 30 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.pmDesc30 &&
                          portfolioManagementRow.pmDesc30.length > 30
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-tooltip
                    :label="
                      portfolioManagementRow.desc240
                        ? portfolioManagementRow.desc240
                        : ''
                    "
                    type="is-light"
                    position="is-bottom"
                  >
                    <b-input
                      type="text"
                      class="desc240"
                      v-bind:class="
                        isApiErrorField(
                          portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                          'desc240',
                          portfolioManagementRow.desc240
                        )
                      "
                      oninput="this.value = this.value.replace(/[^a-zA-Z0-9 .%/\\\\\)\(\]\[-]/g, '');if (this.value.length > 240)
                          this.value = this.value.slice(0, 240);"
                      :value="portfolioManagementRow.desc240"
                      @change.native="
                        portfolioManagementRow.desc240 = $event.target.value
                      "
                      :tabindex="
                        portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                      "
                    ></b-input>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider :bails="false" v-slot="{ classes }" immediate>
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="desc1000"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'desc1000',
                        portfolioManagementRow.desc1000
                      )
                    "
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9 .%/\\\\\)\(\]\[-]/g, '');;if (this.value.length > 1000)
                          this.value = this.value.slice(0, 1000);"
                    :value="portfolioManagementRow.desc1000"
                    @change.native="
                      portfolioManagementRow.desc1000 = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td class="item-status">
              <ValidationProvider
                rules="oneOf:Approved,Rejected"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="indStatus"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.indStatus"
                    class="apprvlStatus"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'apprvlStatus',
                        portfolioManagementRow.indStatus
                      )
                    "
                    @input="
                      portfolioManagementRow.indStatus === 'Rejected'
                        ? (portfolioManagementRow.rejectedBy = loginNetworkId)
                        : (portfolioManagementRow.rejectedBy = '')
                    "
                    :tabindex="
                      (psToRework &&
                        portfolioManagementRow.rejectedBy !== loginNetworkId &&
                        (portfolioManagementRow.apprvlStatus === 'R' ||
                          portfolioManagementRow.indStatus === 'Rejected')) ||
                      (portfolioManagementRow.rejectedBy !== loginNetworkId &&
                        portfolioManagementRow.rejectedByRole > 2 &&
                        (portfolioManagementRow.apprvlStatus === 'R' ||
                          portfolioManagementRow.indStatus === 'Rejected')) ||
                      (portfolioManagementRow.rejectedBy === 'CAS' &&
                        (portfolioManagementRow.apprvlStatus === 'R' ||
                          portfolioManagementRow.indStatus === 'Rejected'))
                        ? -1
                        : 0
                    "
                  >
                    <option value="Not Reviewed">Not Reviewed</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td class="item-rejection-reason">
              <ValidationProvider
                rules="required_if:indStatus,Rejected"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-tooltip
                    :label="
                      portfolioManagementRow.rejectionReason
                        ? portfolioManagementRow.rejectionReason
                        : ''
                    "
                    type="is-light"
                    position="is-bottom"
                  >
                    <b-input
                      type="text"
                      :value="portfolioManagementRow.rejectionReason"
                      @change.native="
                        portfolioManagementRow.rejectionReason =
                          $event.target.value
                      "
                      class="rejectionReason"
                      :disabled="disableOnStatus(portfolioManagementRow)"
                      :tabindex="
                        (psToRework &&
                          portfolioManagementRow.rejectedBy !==
                            loginNetworkId &&
                          (portfolioManagementRow.apprvlStatus === 'R' ||
                            portfolioManagementRow.indStatus === 'Rejected')) ||
                        (portfolioManagementRow.rejectedBy !== loginNetworkId &&
                          portfolioManagementRow.rejectedByRole > 2 &&
                          (portfolioManagementRow.apprvlStatus === 'R' ||
                            portfolioManagementRow.indStatus === 'Rejected')) ||
                        (portfolioManagementRow.rejectedBy === 'CAS' &&
                          (portfolioManagementRow.apprvlStatus === 'R' ||
                            portfolioManagementRow.indStatus === 'Rejected'))
                          ? -1
                          : 0
                      "
                    >
                    </b-input>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                class="suppUom"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'suppUom',
                    portfolioManagementRow.suppUom
                  )
                "
                v-model="portfolioManagementRow.suppUom"
                :value="
                  portfolioManagementRow.suppUom === undefined
                    ? (portfolioManagementRow.suppUom = ' ')
                    : portfolioManagementRow.suppUom
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option><option value="CS">Case</option>
                <option value="EA">Each</option>
                <option value="PK">Pack</option>
                <option value="PR">Pair</option>
                <option value="NA">NA</option>
              </b-select>
            </td>
            <td>
              <ValidationProvider :bails="false" v-slot="{ classes }" immediate>
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 4)
                          this.value = this.value.slice(0, 4);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suppConv',
                        portfolioManagementRow.suppConv
                      )
                    "
                    class="suppConv"
                    :value="portfolioManagementRow.suppConv"
                    @change.native="
                      portfolioManagementRow.suppConv = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:EA,PR,DZ,PK,CS"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="su"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'su',
                        portfolioManagementRow.su
                      )
                    "
                    class="su"
                    v-model="portfolioManagementRow.su"
                    @input="updateSuDependentValues(portfolioManagementRow)"
                    :value="
                      portfolioManagementRow.su === undefined
                        ? (portfolioManagementRow.su = ' ')
                        : portfolioManagementRow.su
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option><option value="EA">Each</option
                    ><option value="PR">Pair</option
                    ><option value="DZ">Dozen</option
                    ><option value="PK">Pack</option
                    ><option value="CS">Case</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                :rules="{
                  required: true,
                  checkValidBasedOnSu: { suVal: '@su' },
                  min_value: 1
                }"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    :disabled="disableBasedOnSu(portfolioManagementRow.su)"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.length > 9)
                          this.value = this.value.slice(0, 9);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suQty',
                        portfolioManagementRow.suQty
                      )
                    "
                    class="suQty"
                    :value="
                      portfolioManagementRow.suQty !== undefined
                        ? addTwoZeros(portfolioManagementRow.suQty)
                        : portfolioManagementRow.suQty
                    "
                    @change.native="
                      portfolioManagementRow.suQty = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required|min_value:0.0001"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    @input="calculateDiscount(portfolioManagementRow)"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suCost',
                        portfolioManagementRow.suCost
                      )
                    "
                    class="suCost"
                    :value="
                      portfolioManagementRow.suCost !== undefined
                        ? addFourZeros(portfolioManagementRow.suCost)
                        : portfolioManagementRow.suCost
                    "
                    @change.native="
                      portfolioManagementRow.suCost = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="isUser3PPMTab"
                rules="min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    @input="calculateDiscount(portfolioManagementRow)"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suList',
                        portfolioManagementRow.suList
                      )
                    "
                    class="suList"
                    :value="
                      portfolioManagementRow.suList !== undefined
                        ? addTwoZeros(portfolioManagementRow.suList)
                        : portfolioManagementRow.suList
                    "
                    @change.native="
                      portfolioManagementRow.suList = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                rules="required|min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    @input="calculateDiscount(portfolioManagementRow)"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suList',
                        portfolioManagementRow.suList
                      )
                    "
                    class="suList"
                    :value="
                      portfolioManagementRow.suList !== undefined
                        ? addTwoZeros(portfolioManagementRow.suList)
                        : portfolioManagementRow.suList
                    "
                    @change.native="
                      portfolioManagementRow.suList = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider :bails="false" v-slot="{ classes }">
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'discnt',
                        portfolioManagementRow.discnt
                      )
                    "
                    class="discnt"
                    :value="
                      portfolioManagementRow.discnt !== undefined
                        ? addPercentMode(portfolioManagementRow.discnt)
                        : portfolioManagementRow.discnt
                    "
                    @change.native="
                      portfolioManagementRow.discnt = $event.target.value
                    "
                    disabled="disabled"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required|min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');  if (this.value.split('.')[0].length > 5)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 5) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 5);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suWt',
                        portfolioManagementRow.suWt
                      )
                    "
                    class="suWt"
                    :disabled="isUser3PPMTab"
                    :value="
                      portfolioManagementRow.suWt !== undefined
                        ? addTwoZeros(portfolioManagementRow.suWt)
                        : portfolioManagementRow.suWt
                    "
                    @change.native="
                      portfolioManagementRow.suWt = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required|min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');  if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suLen',
                        portfolioManagementRow.suLen
                      )
                    "
                    class="suLen"
                    :disabled="isUser3PPMTab"
                    :value="
                      portfolioManagementRow.suLen !== undefined
                        ? addTwoZeros(portfolioManagementRow.suLen)
                        : ''
                    "
                    @change.native="
                      portfolioManagementRow.suLen = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required|min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suWid',
                        portfolioManagementRow.suWid
                      )
                    "
                    class="suWid"
                    :disabled="isUser3PPMTab"
                    :value="
                      portfolioManagementRow.suWid !== undefined
                        ? addTwoZeros(portfolioManagementRow.suWid)
                        : ''
                    "
                    @change.native="
                      portfolioManagementRow.suWid = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required|min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suHt',
                        portfolioManagementRow.suHt
                      )
                    "
                    class="suHt"
                    :disabled="isUser3PPMTab"
                    :value="
                      portfolioManagementRow.suHt !== undefined
                        ? addTwoZeros(portfolioManagementRow.suHt)
                        : portfolioManagementRow.suHt
                    "
                    @change.native="
                      portfolioManagementRow.suHt = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                :rules="{ valOfAu: { suVal: '@su' } }"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="au"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'au',
                        portfolioManagementRow.au
                      )
                    "
                    class="au"
                    @input="updateAuDependentValues(portfolioManagementRow)"
                    :disabled="portfolioManagementRow.su === 'CS'"
                    v-model="portfolioManagementRow.au"
                    :value="
                      portfolioManagementRow.au === undefined
                        ? (portfolioManagementRow.au = ' ')
                        : portfolioManagementRow.au
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option><option value="DZ">Dozen</option>
                    <option value="PK">Pack</option>
                    <option value="CS">Case</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:au,DZ,PK,CS"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 10)
                          this.value = this.value.slice(0, 10);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'auQty',
                        portfolioManagementRow.auQty
                      )
                    "
                    class="auQty"
                    :disabled="
                      disableAuQtyIf(
                        portfolioManagementRow.su,
                        portfolioManagementRow.au
                      )
                    "
                    :value="portfolioManagementRow.auQty"
                    @change.native="
                      portfolioManagementRow.auQty = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:au,DZ,PK,CS"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'auList',
                        portfolioManagementRow.auList
                      )
                    "
                    class="auList"
                    :disabled="
                      portfolioManagementRow.su === 'CS' ||
                        portfolioManagementRow.au === '' ||
                        portfolioManagementRow.au === ' ' ||
                        portfolioManagementRow.au === undefined
                    "
                    :value="
                      portfolioManagementRow.auList !== undefined
                        ? addTwoZeros(portfolioManagementRow.auList)
                        : portfolioManagementRow.auList
                    "
                    @change.native="
                      portfolioManagementRow.auList = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                name="field"
                rules="required_if:au,DZ,PK,CS"
                :bails="false"
                v-slot="{
                  classes
                }"
                immediate
                ><div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 5)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 5) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 5);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'auWt',
                        portfolioManagementRow.auWt
                      )
                    "
                    class="auWt"
                    :disabled="
                      portfolioManagementRow.su === 'CS' ||
                        portfolioManagementRow.au === '' ||
                        portfolioManagementRow.au === ' ' ||
                        portfolioManagementRow.au === undefined
                    "
                    :value="
                      portfolioManagementRow.auWt !== undefined
                        ? addTwoZeros(portfolioManagementRow.auWt)
                        : portfolioManagementRow.auWt
                    "
                    @change.native="
                      portfolioManagementRow.auWt = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                name="field"
                rules="required_if:au,DZ,PK,CS"
                :bails="false"
                v-slot="{
                  classes
                }"
                immediate
                ><div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'auLen',
                        portfolioManagementRow.auLen
                      )
                    "
                    class="auLen"
                    :disabled="
                      portfolioManagementRow.su === 'CS' ||
                        portfolioManagementRow.au === '' ||
                        portfolioManagementRow.au === ' ' ||
                        portfolioManagementRow.au === undefined
                    "
                    :value="
                      portfolioManagementRow.auLen !== undefined
                        ? addTwoZeros(portfolioManagementRow.auLen)
                        : portfolioManagementRow.auLen
                    "
                    @change.native="
                      portfolioManagementRow.auLen = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                name="field"
                rules="required_if:au,DZ,PK,CS"
                :bails="false"
                v-slot="{
                  classes
                }"
                immediate
                ><div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'auWid',
                        portfolioManagementRow.auWid
                      )
                    "
                    class="auWid"
                    :disabled="
                      portfolioManagementRow.su === 'CS' ||
                        portfolioManagementRow.au === '' ||
                        portfolioManagementRow.au === ' ' ||
                        portfolioManagementRow.au === undefined
                    "
                    :value="
                      portfolioManagementRow.auWid !== undefined
                        ? addTwoZeros(portfolioManagementRow.auWid)
                        : portfolioManagementRow.auWid
                    "
                    @change.native="
                      portfolioManagementRow.auWid = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                name="field"
                rules="required_if:au,DZ,PK,CS"
                :bails="false"
                v-slot="{
                  classes
                }"
                immediate
                ><div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'auHt',
                        portfolioManagementRow.auHt
                      )
                    "
                    class="auHt"
                    :disabled="
                      portfolioManagementRow.su === 'CS' ||
                        portfolioManagementRow.au === '' ||
                        portfolioManagementRow.au === ' ' ||
                        portfolioManagementRow.au === undefined
                    "
                    :value="
                      portfolioManagementRow.auHt !== undefined
                        ? addTwoZeros(portfolioManagementRow.auHt)
                        : portfolioManagementRow.auHt
                    "
                    @change.native="
                      portfolioManagementRow.auHt = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required|min_value:0.01"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                    v-bind:class="[
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'suListFinal',
                        portfolioManagementRow.suListFinal
                      ),
                      loginRole === 1 || loginRole === 2
                        ? isSuListFinalValueValid(portfolioManagementRow)
                        : ''
                    ]"
                    class="suListFinal text-align-right"
                    :value="
                      portfolioManagementRow.suListFinal !== undefined
                        ? addTwoZeros(portfolioManagementRow.suListFinal)
                        : portfolioManagementRow.suListFinal
                    "
                    @change.native="
                      portfolioManagementRow.suListFinal = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                v-bind:class="[
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'auListFinal',
                    portfolioManagementRow.auListFinal
                  ),
                  isAuListFinalValueValid(portfolioManagementRow)
                ]"
                class="auListFinal text-align-right"
                :disabled="
                  portfolioManagementRow.au === '' ||
                    portfolioManagementRow.au === ' ' ||
                    portfolioManagementRow.au === undefined
                "
                :value="
                  portfolioManagementRow.auListFinal !== undefined
                    ? addTwoZeros(portfolioManagementRow.auListFinal)
                    : portfolioManagementRow.auListFinal
                "
                @change.native="
                  portfolioManagementRow.auListFinal = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                v-if="isUser3PPMTab"
                type="text"
                oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'tradMa',
                    portfolioManagementRow.tradMa
                  )
                "
                class="tradMa text-align-right"
                :value="
                  portfolioManagementRow.tradMa !== undefined
                    ? addFourZeros(portfolioManagementRow.tradMa)
                    : portfolioManagementRow.tradMa
                "
                @change.native="
                  portfolioManagementRow.tradMa = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
              <ValidationProvider
                v-else
                rules="required|min_value:0"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'tradMa',
                        portfolioManagementRow.tradMa
                      )
                    "
                    class="tradMa text-align-right"
                    :value="
                      portfolioManagementRow.tradMa !== undefined
                        ? addFourZeros(portfolioManagementRow.tradMa)
                        : portfolioManagementRow.tradMa
                    "
                    @change.native="
                      portfolioManagementRow.tradMa = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (portfolioManagementRow.unitUse === 'EA' ||
                    portfolioManagementRow.su === 'EA') &&
                    (portfolioManagementRow.medDevice === 'I' ||
                      portfolioManagementRow.medDevice === 'II' ||
                      portfolioManagementRow.medDevice === 'III')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'gtinEa',
                        portfolioManagementRow.gtinEa
                      )
                    "
                    class="gtinEa"
                    :value="portfolioManagementRow.gtinEa"
                    @change.native="
                      portfolioManagementRow.gtinEa = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'gtinEa',
                    portfolioManagementRow.gtinEa
                  )
                "
                class="gtinEa"
                :value="portfolioManagementRow.gtinEa"
                @change.native="
                  portfolioManagementRow.gtinEa = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (portfolioManagementRow.su === 'PK' ||
                    portfolioManagementRow.au === 'PK') &&
                    (portfolioManagementRow.medDevice === 'I' ||
                      portfolioManagementRow.medDevice === 'II' ||
                      portfolioManagementRow.medDevice === 'III')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'gtinPk',
                        portfolioManagementRow.gtinPk
                      )
                    "
                    class="gtinPk"
                    :value="portfolioManagementRow.gtinPk"
                    @change.native="
                      portfolioManagementRow.gtinPk = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'gtinPk',
                    portfolioManagementRow.gtinPk
                  )
                "
                class="gtinPk"
                :value="portfolioManagementRow.gtinPk"
                @change.native="
                  portfolioManagementRow.gtinPk = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (portfolioManagementRow.su === 'CS' ||
                    portfolioManagementRow.au === 'CS') &&
                    (portfolioManagementRow.medDevice === 'I' ||
                      portfolioManagementRow.medDevice === 'II' ||
                      portfolioManagementRow.medDevice === 'III')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'gtinCs',
                        portfolioManagementRow.gtinCs
                      )
                    "
                    class="gtinCs"
                    :value="portfolioManagementRow.gtinCs"
                    @change.native="
                      portfolioManagementRow.gtinCs = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'gtinCs',
                    portfolioManagementRow.gtinCs
                  )
                "
                class="gtinCs"
                :value="portfolioManagementRow.gtinCs"
                @change.native="
                  portfolioManagementRow.gtinCs = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  portfolioManagementRow.medDevice === 'None' &&
                    (portfolioManagementRow.au === 'DZ' ||
                      portfolioManagementRow.au === 'PK' ||
                      portfolioManagementRow.au === 'CS')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'upcAlt',
                        portfolioManagementRow.upcAlt
                      )
                    "
                    class="upcAlt"
                    :value="portfolioManagementRow.upcAlt"
                    @change.native="
                      portfolioManagementRow.upcAlt = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'upcAlt',
                    portfolioManagementRow.upcAlt
                  )
                "
                class="upcAlt"
                :value="portfolioManagementRow.upcAlt"
                @change.native="
                  portfolioManagementRow.upcAlt = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  portfolioManagementRow.caCurrency === 'CDN' &&
                    (portfolioManagementRow.au === 'DZ' ||
                      portfolioManagementRow.au === 'PK' ||
                      portfolioManagementRow.au === 'CS')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'caAuList',
                        portfolioManagementRow.caAuList
                      )
                    "
                    class="caAuList text-align-right"
                    :disabled="
                      portfolioManagementRow.su === 'CS' ||
                        portfolioManagementRow.au === '' ||
                        portfolioManagementRow.au === ' ' ||
                        portfolioManagementRow.au === undefined
                    "
                    :value="
                      portfolioManagementRow.caAuList !== undefined
                        ? addTwoZeros(portfolioManagementRow.caAuList)
                        : portfolioManagementRow.caAuList
                    "
                    @change.native="
                      portfolioManagementRow.caAuList = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'caAuList',
                    portfolioManagementRow.caAuList
                  )
                "
                class="caAuList text-align-right"
                :disabled="
                  portfolioManagementRow.su === 'CS' ||
                    portfolioManagementRow.au === '' ||
                    portfolioManagementRow.au === ' ' ||
                    portfolioManagementRow.au === undefined
                "
                :value="
                  portfolioManagementRow.caAuList !== undefined
                    ? addTwoZeros(portfolioManagementRow.caAuList)
                    : portfolioManagementRow.caAuList
                "
                @change.native="
                  portfolioManagementRow.caAuList = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'pc'">
              <ValidationProvider
                :rules="{ required: true, isPcValid: { mcsVal: '@mcs' } }"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="pcOptions"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'pc',
                        portfolioManagementRow.pc
                      )
                    "
                    class="pc"
                    :disabled="portfolioManagementRow.apprvlStatus === 'R'"
                    v-model="portfolioManagementRow.pc"
                    @input="
                      changeOnPortfolioManagementRow(
                        $event,
                        index,
                        portfolioManagementRow,
                        portfolioManagementColumns
                      )
                    "
                    @search="fetchTypeAhead"
                    :title="portfolioManagementRow.pc"
                  >
                    <template slot="option" slot-scope="pcOption">
                      <div class="d-center">
                        {{ pcOption.label }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="pcOption"
                      title="pcOption"
                    >
                      <div class="selected d-center">
                        {{ pcOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'byrCode'">
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="byrCodeOptions"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'byrCd',
                        portfolioManagementRow.byrCd
                      )
                    "
                    class="byrCd"
                    :disabled="portfolioManagementRow.apprvlStatus === 'R'"
                    v-model="portfolioManagementRow.byrCd"
                    @input="
                      changeOnPortfolioManagementRow(
                        $event,
                        index,
                        portfolioManagementRow,
                        portfolioManagementColumns
                      )
                    "
                    @search="fetchTypeAhead"
                    :title="portfolioManagementRow.byrCd"
                  >
                    <template slot="option" slot-scope="byrCodeOption">
                      <div class="d-center">
                        {{ byrCodeOption.label }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="byrCodeOption"
                      title="byrCodeOption"
                    >
                      <div class="selected d-center">
                        {{ byrCodeOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 6)
                        this.value = this.value.slice(0, 6);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'vma',
                        portfolioManagementRow.vma
                      )
                    "
                    class="vma text-align-right"
                    :value="portfolioManagementRow.vma"
                    @change.native="
                      portfolioManagementRow.vma = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 3)
                        this.value = this.value.slice(0, 3);"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'vpa',
                        portfolioManagementRow.vpa
                      )
                    "
                    class="vpa text-align-right"
                    :value="portfolioManagementRow.vpa"
                    :disabled="isUser3PPMTab"
                    @change.native="
                      portfolioManagementRow.vpa = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'sbu'">
              <v-select
                :class="[
                  isUser3PPMTab === false &&
                  (loginRole === 1 || loginRole === 2) &&
                  portfolioManagementRow.sbu === undefined
                    ? 'invalid'
                    : '',
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'sbu',
                    portfolioManagementRow.sbu
                  )
                ]"
                :filterable="false"
                :options="sbuCodeOptions"
                :selectable="sbuCodeOption => sbuCodeOption.deleteFlag !== 'Y'"
                class="sbu"
                :disabled="
                  isUser3PPMTab || portfolioManagementRow.apprvlStatus === 'R'
                "
                v-model="portfolioManagementRow.sbu"
                @input="
                  portfolioManagementRow.sbu = portfolioManagementRow.sbu
                    ? portfolioManagementRow.sbu.sbuCodeDesc
                    : portfolioManagementRow.sbu;
                  changeOnPortfolioManagementRow(
                    $event,
                    index,
                    portfolioManagementRow,
                    portfolioManagementColumns
                  );
                "
                @search="fetchTypeAhead"
                :title="portfolioManagementRow.sbu"
              >
                <template slot="option" slot-scope="sbuCodeOption">
                  <div class="d-center">
                    {{ sbuCodeOption.sbuCodeDesc }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="sbuCodeOption"
                  title="sbuCodeOption"
                >
                  <div class="selected d-center">
                    {{ sbuCodeOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'cdc'">
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="cdcOptions"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'cdc',
                        portfolioManagementRow.cdc
                      )
                    "
                    class="cdc"
                    :disabled="
                      disableOnDisc(portfolioManagementRow) ||
                        portfolioManagementRow.apprvlStatus === 'R'
                    "
                    v-model="portfolioManagementRow.cdc"
                    @input="
                      changeOnPortfolioManagementRow(
                        $event,
                        index,
                        portfolioManagementRow,
                        portfolioManagementColumns
                      )
                    "
                    @search="fetchTypeAhead"
                    :title="portfolioManagementRow.cdc"
                  >
                    <template slot="option" slot-scope="cdcOption">
                      <div class="d-center">
                        {{ cdcOption.label }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="cdcOption"
                      title="cdcOption"
                    >
                      <div class="selected d-center">
                        {{ cdcOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:1,2,3,4,5,6"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'prdFam',
                        portfolioManagementRow.prdFam
                      )
                    "
                    class="prdFam"
                    v-model="portfolioManagementRow.prdFam"
                    :value="
                      portfolioManagementRow.prdFam === undefined
                        ? (portfolioManagementRow.prdFam = ' ')
                        : portfolioManagementRow.prdFam
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="1">1 - Research</option>
                    <option value="2">2 - Healthcare</option>
                    <option value="3">3 - Safety</option>
                    <option value="4">4 - FSE</option>
                    <option value="5">5 - FSD</option>
                    <option value="6">6 - Third Party</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:03,07"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'prodType',
                        portfolioManagementRow.prodType
                      )
                    "
                    class="prodType"
                    v-model="portfolioManagementRow.prodType"
                    :value="
                      portfolioManagementRow.prodType === undefined
                        ? (portfolioManagementRow.prodType = ' ')
                        : portfolioManagementRow.prodType
                    "
                    disabled="disabled"
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="03">03</option>
                    <option value="07">07</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'cct'">
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="cctOptions"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'cct',
                        portfolioManagementRow.cct
                      )
                    "
                    class="cct"
                    v-model="portfolioManagementRow.cct"
                    @input="
                      changeOnPortfolioManagementRow(
                        $event,
                        index,
                        portfolioManagementRow,
                        portfolioManagementColumns
                      )
                    "
                    @search="fetchTypeAhead"
                    :title="portfolioManagementRow.cct"
                    :disabled="portfolioManagementRow.apprvlStatus === 'R'"
                  >
                    <template slot="option" slot-scope="cctOption">
                      <div class="d-center">
                        {{ cctOption.label }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="cctOption"
                      title="cctOption"
                    >
                      <div class="selected d-center">
                        {{ cctOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:10,15,20,25,30,40,45,50,55,60,65,90,95"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'mcp',
                        portfolioManagementRow.mcp
                      )
                    "
                    class="mcp"
                    :disabled="isUser3PPMTab"
                    v-model="portfolioManagementRow.mcp"
                    :value="
                      portfolioManagementRow.mcp === undefined
                        ? (portfolioManagementRow.mcp = ' ')
                        : portfolioManagementRow.mcp
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="10">10 - General Distribution</option>
                    <option value="15">15 - Chemical</option>
                    <option value="20">20 - Biotech</option>
                    <option value="25">25 - Clinical</option>
                    <option value="30">30 - Safety</option>
                    <option value="40">40 - US Regions</option>
                    <option value="45">45 - FFD</option>
                    <option value="50">50 - FSD</option>
                    <option value="55">55 - FSE</option>
                    <option value="60">60 - Canada</option>
                    <option value="65">65 - International</option>
                    <option value="90">90 - Other</option>
                    <option value="95">95 - Third Party</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="isUser3PPMTab"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="mcs"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'mcs',
                        portfolioManagementRow.mcs
                      )
                    "
                    class="mcs"
                    disabled
                    v-model="portfolioManagementRow.mcs"
                    :value="
                      portfolioManagementRow.mcs === undefined
                        ? (portfolioManagementRow.mcs = ' ')
                        : portfolioManagementRow.mcs
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option
                      v-for="mcsCode in mcsCodes"
                      :value="mcsCode"
                      :key="mcsCode.id"
                      >{{ mcsCode }}
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                :rules="{ oneOf: mcsCodes }"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="mcs"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'mcs',
                        portfolioManagementRow.mcs
                      )
                    "
                    class="mcs"
                    v-model="portfolioManagementRow.mcs"
                    :value="
                      portfolioManagementRow.mcs === undefined
                        ? (portfolioManagementRow.mcs = ' ')
                        : portfolioManagementRow.mcs
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option
                      v-for="mcsCode in mcsCodes"
                      :value="mcsCode"
                      :key="mcsCode.id"
                      >{{ mcsCode }}
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:E,L,B,F,M,X,V,G"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'lcp',
                        portfolioManagementRow.lcp
                      )
                    "
                    class="lcp"
                    v-model="portfolioManagementRow.lcp"
                    :value="
                      portfolioManagementRow.lcp === undefined
                        ? (portfolioManagementRow.lcp = ' ')
                        : portfolioManagementRow.lcp
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="E"
                      >E - Fisherbrand, Thermo Fisher Scientific owned</option
                    >
                    <option value="L">L - Fisherbrand, outside Supplied</option>
                    <option value="B"
                      >B - Private label, outside Supplied</option
                    >
                    <option value="F"
                      >F - Private label, Thermo Fisher Scientific owned but
                      sourced</option
                    >
                    <option value="M"
                      >M - Private label, Thermo Fisher Scientific owned and
                      manufactured</option
                    >
                    <option value="X"
                      >X - Supplier branded, Thermo Fisher Scientific
                      owned</option
                    >
                    <option value="V"
                      >V - Supplier branded, outside supplied</option
                    >
                    <option value="G">G - Generic</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'pvrLbl',
                    portfolioManagementRow.pvrLbl
                  )
                "
                class="pvrLbl"
                v-model="portfolioManagementRow.pvrLbl"
                :value="
                  portfolioManagementRow.pvrLbl === undefined
                    ? (portfolioManagementRow.pvrLbl = ' ')
                    : portfolioManagementRow.pvrLbl
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
                ><option value=" "> </option>
                <option value="H">H - Fisher High List Product</option>
                <option value="F">F - Fisherbrand Supply Item</option>
                <option value="NA">NA - Not Private Label</option>
              </b-select>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'rsPrf',
                    portfolioManagementRow.rsPrf
                  )
                "
                class="rsPrf"
                v-model="portfolioManagementRow.rsPrf"
                :value="
                  portfolioManagementRow.rsPrf === undefined
                    ? (portfolioManagementRow.rsPrf = ' ')
                    : portfolioManagementRow.rsPrf
                "
                disabled
                ><option value=" "></option>
                <option value="S">S</option>
                <option value="C">C</option>
                <option value="G">G</option>
                <option value="NA">NA</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:S,C,G,NA"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'rsPrf',
                        portfolioManagementRow.rsPrf
                      )
                    "
                    class="rsPrf"
                    v-model="portfolioManagementRow.rsPrf"
                    :value="
                      portfolioManagementRow.rsPrf === undefined
                        ? (portfolioManagementRow.rsPrf = ' ')
                        : portfolioManagementRow.rsPrf
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="S">S</option>
                    <option value="C">C</option>
                    <option value="G">G</option>
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'hcPrf',
                    portfolioManagementRow.hcPrf
                  )
                "
                class="hcPrf"
                v-model="portfolioManagementRow.hcPrf"
                :value="
                  portfolioManagementRow.hcPrf === undefined
                    ? (portfolioManagementRow.hcPrf = ' ')
                    : portfolioManagementRow.hcPrf
                "
                disabled
                ><option value=" "></option>
                <option value="S">S</option>
                <option value="C">C</option>
                <option value="G">G</option>
                <option value="NA">NA</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:S,C,G,NA"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'hcPrf',
                        portfolioManagementRow.hcPrf
                      )
                    "
                    class="hcPrf"
                    v-model="portfolioManagementRow.hcPrf"
                    :value="
                      portfolioManagementRow.hcPrf === undefined
                        ? (portfolioManagementRow.hcPrf = ' ')
                        : portfolioManagementRow.hcPrf
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="S">S</option>
                    <option value="C">C</option>
                    <option value="G">G</option>
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'sfPrf',
                    portfolioManagementRow.sfPrf
                  )
                "
                class="sfPrf"
                v-model="portfolioManagementRow.sfPrf"
                :value="
                  portfolioManagementRow.sfPrf === undefined
                    ? (portfolioManagementRow.sfPrf = ' ')
                    : portfolioManagementRow.sfPrf
                "
                disabled
                ><option value=" "></option>
                <option value="S">S</option>
                <option value="C">C</option>
                <option value="G">G</option>
                <option value="NA">NA</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:S,C,G,NA"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'sfPrf',
                        portfolioManagementRow.sfPrf
                      )
                    "
                    class="sfPrf"
                    v-model="portfolioManagementRow.sfPrf"
                    :value="
                      portfolioManagementRow.sfPrf === undefined
                        ? (portfolioManagementRow.sfPrf = ' ')
                        : portfolioManagementRow.sfPrf
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="S">S</option>
                    <option value="C">C</option>
                    <option value="G">G</option>
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'taxonomy'">
              <v-select
                v-if="isUser3PPMTab"
                :filterable="false"
                :options="taxonomyOptions"
                :selectable="
                  taxonomyOption => taxonomyOption.deleteFlag !== 'Y'
                "
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'taxonomy',
                    portfolioManagementRow.taxonomy
                  )
                "
                class="taxonomy"
                v-model="portfolioManagementRow.taxonomy"
                @input="
                  portfolioManagementRow.taxonomy = portfolioManagementRow.taxonomy
                    ? portfolioManagementRow.taxonomy.taxoCodeDesc
                    : portfolioManagementRow.taxonomy;
                  changeOnPortfolioManagementRow(
                    $event,
                    index,
                    portfolioManagementRow,
                    portfolioManagementColumns
                  );
                "
                @search="fetchTypeAhead"
                :title="portfolioManagementRow.taxonomy"
                :disabled="portfolioManagementRow.apprvlStatus === 'R'"
              >
                <template slot="option" slot-scope="taxonomyOption">
                  <div class="d-center">
                    {{ taxonomyOption.taxoCodeDesc }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="taxonomyOption"
                  title="taxonomyOption"
                >
                  <div class="selected d-center">
                    {{ taxonomyOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
              <ValidationProvider
                v-else
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="taxonomyOptions"
                    :selectable="
                      taxonomyOption => taxonomyOption.deleteFlag !== 'Y'
                    "
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'taxonomy',
                        portfolioManagementRow.taxonomy
                      )
                    "
                    class="taxonomy"
                    :disabled="portfolioManagementRow.apprvlStatus === 'R'"
                    v-model="portfolioManagementRow.taxonomy"
                    @input="
                      portfolioManagementRow.taxonomy = portfolioManagementRow.taxonomy
                        ? portfolioManagementRow.taxonomy.taxoCodeDesc
                        : portfolioManagementRow.taxonomy;
                      changeOnPortfolioManagementRow(
                        $event,
                        index,
                        portfolioManagementRow,
                        portfolioManagementColumns
                      );
                    "
                    @search="fetchTypeAhead"
                    :title="portfolioManagementRow.taxonomy"
                  >
                    <template slot="option" slot-scope="taxonomyOption">
                      <div class="d-center">
                        {{ taxonomyOption.taxoCodeDesc }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="taxonomyOption"
                      title="taxonomyOption"
                    >
                      <div class="selected d-center">
                        {{ taxonomyOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="isUser3PPMTab"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="serLotPM"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.serLotPM"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'serLotPM',
                        portfolioManagementRow.serLotPM
                      )
                    "
                    class="serLotPM"
                    :value="
                      portfolioManagementRow.serLotPM === undefined
                        ? (portfolioManagementRow.serLotPM = ' ')
                        : portfolioManagementRow.serLotPM
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="S">Serial</option>
                    <option value="L">Lot</option>
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                rules="oneOf:S,L,NA"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="serLotPM"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.serLotPM"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'serLotPM',
                        portfolioManagementRow.serLotPM
                      )
                    "
                    class="serLotPM"
                    :value="
                      portfolioManagementRow.serLotPM === undefined
                        ? (portfolioManagementRow.serLotPM = ' ')
                        : portfolioManagementRow.serLotPM
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                    ><option value=" "></option>
                    <option value="S">Serial</option>
                    <option value="L">Lot</option>
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-model="portfolioManagementRow.iceChg"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'iceChg',
                    portfolioManagementRow.iceChg
                  )
                "
                class="iceChg"
                :value="
                  portfolioManagementRow.iceChg === undefined
                    ? (portfolioManagementRow.iceChg = ' ')
                    : portfolioManagementRow.iceChg
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.iceChg"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'iceChg',
                        portfolioManagementRow.iceChg
                      )
                    "
                    class="iceChg"
                    :value="
                      portfolioManagementRow.iceChg === undefined
                        ? (portfolioManagementRow.iceChg = ' ')
                        : portfolioManagementRow.iceChg
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-model="portfolioManagementRow.ipf"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'ipf',
                    portfolioManagementRow.ipf
                  )
                "
                class="ipf"
                :value="
                  portfolioManagementRow.ipf === undefined
                    ? (portfolioManagementRow.ipf = ' ')
                    : portfolioManagementRow.ipf
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option>
                <option value="1"
                  >1 - Product requires cold pack packaging with a $7.00
                  fee</option
                >
                <option value="2"
                  >2 - Product requires dry pack packaging with a $9.50
                  fee</option
                >
                <option value="N">Not Required</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:1,2,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.ipf"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'ipf',
                        portfolioManagementRow.ipf
                      )
                    "
                    class="ipf"
                    :value="
                      portfolioManagementRow.ipf === undefined
                        ? (portfolioManagementRow.ipf = ' ')
                        : portfolioManagementRow.ipf
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="1"
                      >1 - Product requires cold pack packaging with a $7.00
                      fee</option
                    >
                    <option value="2"
                      >2 - Product requires dry pack packaging with a $9.50
                      fee</option
                    >
                    <option value="N">Not Required</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'oldMkt'">
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="oldMktOptions"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'oldMkt',
                        portfolioManagementRow.oldMkt
                      )
                    "
                    class="oldMkt"
                    :disabled="portfolioManagementRow.apprvlStatus === 'R'"
                    v-model="portfolioManagementRow.oldMkt"
                    @input="
                      changeOnPortfolioManagementRow(
                        $event,
                        index,
                        portfolioManagementRow,
                        portfolioManagementColumns
                      )
                    "
                    @search="fetchTypeAhead"
                    :title="portfolioManagementRow.oldMkt"
                  >
                    <template slot="option" slot-scope="oldMktOption">
                      <div class="d-center">
                        {{ oldMktOption.label }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="oldMktOption"
                      title="oldMktOption"
                    >
                      <div class="selected d-center">
                        {{ oldMktOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-model="portfolioManagementRow.dirShip"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'dirShip',
                    portfolioManagementRow.dirShip
                  )
                "
                class="dirShip"
                disabled
                :value="
                  portfolioManagementRow.dirShip === undefined
                    ? (portfolioManagementRow.dirShip = ' ')
                    : portfolioManagementRow.dirShip
                "
              >
                <option value=" "></option>
                <option value="D">D - Direct Ship</option>
                <option value="E">E - Express Direct Ship</option>
                <option value="N">N - Not Direct Ship</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:D,E,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.dirShip"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'dirShip',
                        portfolioManagementRow.dirShip
                      )
                    "
                    class="dirShip"
                    :value="
                      portfolioManagementRow.dirShip === undefined
                        ? (portfolioManagementRow.dirShip = ' ')
                        : portfolioManagementRow.dirShip
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="D">D - Direct Ship</option>
                    <option value="E">E - Express Direct Ship</option>
                    <option value="N">N - Not Direct Ship</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider v-if="isUser3PPMTab" immediate vid="shlfLf">
                <b-select
                  v-bind:class="
                    isApiErrorField(
                      portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                      'shlfLf',
                      portfolioManagementRow.shlfLf
                    )
                  "
                  class="shlfLf"
                  v-model="portfolioManagementRow.shlfLf"
                  :value="
                    portfolioManagementRow.shlfLf === undefined
                      ? (portfolioManagementRow.shlfLf = ' ')
                      : portfolioManagementRow.shlfLf
                  "
                  :tabindex="
                    portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                  "
                >
                  <option value=" "></option><option value="Y">Yes</option
                  ><option value="N">No</option>
                </b-select>
              </ValidationProvider>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="shlfLf"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'shlfLf',
                        portfolioManagementRow.shlfLf
                      )
                    "
                    class="shlfLf"
                    v-model="portfolioManagementRow.shlfLf"
                    :value="
                      portfolioManagementRow.shlfLf === undefined
                        ? (portfolioManagementRow.shlfLf = ' ')
                        : portfolioManagementRow.shlfLf
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:shlfLf,Y|max_value:3650"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value > 3650) this.value = 3650; this.value === '' ? '' : this.value = +this.value"
                    class="shlfLfNum"
                    v-bind:class="[
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'shlfLfNum',
                        portfolioManagementRow.shlfLfNum
                      ),
                      portfolioManagementRow.shlfLfNum === 0 ||
                      portfolioManagementRow.shlfLfNum <
                        portfolioManagementRow.srcRcv
                        ? 'is-danger'
                        : ''
                    ]"
                    :value="portfolioManagementRow.shlfLfNum"
                    @change.native="
                      portfolioManagementRow.shlfLfNum = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:serLotPM,L"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
        this.value = this.value.slice(0, 3);"
                    v-bind:class="[
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'srcRcv',
                        portfolioManagementRow.srcRcv
                      ),
                      portfolioManagementRow.srcRcv === 0 ||
                      portfolioManagementRow.srcRcv <
                        portfolioManagementRow.srcExp
                        ? 'is-danger'
                        : ''
                    ]"
                    class="srcRcv"
                    v-model="portfolioManagementRow.srcRcv"
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:serLotPM,L"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
        this.value = this.value.slice(0, 3);"
                    v-bind:class="[
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'srcExp',
                        portfolioManagementRow.srcExp
                      ),
                      portfolioManagementRow.srcExp === 0 ? 'is-danger' : ''
                    ]"
                    class="srcExp"
                    v-model="portfolioManagementRow.srcExp"
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:A,C,S"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.prodCls"
                    :value="
                      portfolioManagementRow.prodCls === undefined
                        ? (portfolioManagementRow.prodCls = ' ')
                        : portfolioManagementRow.prodCls
                    "
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'prodCls',
                        portfolioManagementRow.prodCls
                      )
                    "
                    class="prodCls"
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="A">A - Apparatus</option>
                    <option value="C">C - Chemicals</option>
                    <option value="S">S - Education</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-model="portfolioManagementRow.disc"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'disc',
                    portfolioManagementRow.disc
                  )
                "
                class="disc"
                disabled
                :value="
                  portfolioManagementRow.disc === undefined
                    ? (portfolioManagementRow.disc = ' ')
                    : portfolioManagementRow.disc
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.disc"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'disc',
                        portfolioManagementRow.disc
                      )
                    "
                    class="disc"
                    :value="
                      portfolioManagementRow.disc === undefined
                        ? (portfolioManagementRow.disc = ' ')
                        : portfolioManagementRow.disc
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:1,2,6"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.prcType"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'prcType',
                        portfolioManagementRow.prcType
                      )
                    "
                    class="prcType"
                    disabled
                    :value="
                      portfolioManagementRow.prcType === undefined
                        ? (portfolioManagementRow.prcType = ' ')
                        : portfolioManagementRow.prcType
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="1"
                      >1 - Regular item listed and priced in standard unit
                      only</option
                    >
                    <option value="2"
                      >2 - Regular item listed and priced in standard and
                      alternate unit</option
                    >
                    <option value="6"
                      >6 - Discount not allowed item listed and priced in
                      standard and alternate unit</option
                    >
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                v-if="isUser3PPMTab"
                type="text"
                oninput="if (this.value.length > 11)
                     this.value = this.value.slice(0, 11);"
                class="fcatSug"
                :class="[
                  portfolioManagementRow.fcatSugError === 'Dup Sug Fcat'
                    ? 'is-danger'
                    : '',
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'fcatSug',
                    portfolioManagementRow.fcatSug
                  )
                ]"
                :value="portfolioManagementRow.fcatSug"
                @change.native="
                  portfolioManagementRow.fcatSug = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
              <b-input
                v-else-if="isFcatNexInSeries"
                type="text"
                oninput="if (this.value.length > 11)
                     this.value = this.value.slice(0, 11);"
                class="fcatSug"
                :class="[
                  portfolioManagementRow.fcatSugError === 'Dup Sug Fcat'
                    ? 'is-danger'
                    : '',
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'fcatSug',
                    portfolioManagementRow.fcatSug
                  )
                ]"
                :value="portfolioManagementRow.fcatSug"
                @change.native="
                  portfolioManagementRow.fcatSug = $event.target.value
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
              <ValidationProvider
                v-else
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="if (this.value.length > 11)
                     this.value = this.value.slice(0, 11);"
                    class="fcatSug"
                    :class="[
                      portfolioManagementRow.fcatSugError === 'Dup Sug Fcat'
                        ? 'is-danger'
                        : '',
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'fcatSug',
                        portfolioManagementRow.fcatSug
                      )
                    ]"
                    :value="portfolioManagementRow.fcatSug"
                    @change.native="
                      portfolioManagementRow.fcatSug = $event.target.value
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-model="portfolioManagementRow.addPb"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'addPb',
                    portfolioManagementRow.addPb
                  )
                "
                class="addPb"
                :value="
                  portfolioManagementRow.addPb === undefined
                    ? (portfolioManagementRow.addPb = ' ')
                    : portfolioManagementRow.addPb
                "
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.addPb"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'addPb',
                        portfolioManagementRow.addPb
                      )
                    "
                    class="addPb"
                    :value="
                      portfolioManagementRow.addPb === undefined
                        ? (portfolioManagementRow.addPb = ' ')
                        : portfolioManagementRow.addPb
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PPMTab"
                v-model="portfolioManagementRow.author"
                v-bind:class="
                  isApiErrorField(
                    portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                    'author',
                    portfolioManagementRow.author
                  )
                "
                class="author"
                disabled
                :value="
                  portfolioManagementRow.author === undefined
                    ? (portfolioManagementRow.author = ' ')
                    : portfolioManagementRow.author
                "
              >
                <option value=" "></option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="portfolioManagementRow.author"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'author',
                        portfolioManagementRow.author
                      )
                    "
                    class="author"
                    :value="
                      portfolioManagementRow.author === undefined
                        ? (portfolioManagementRow.author = ' ')
                        : portfolioManagementRow.author
                    "
                    :tabindex="
                      portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                type="text"
                :value="portfolioManagementRow.internalComments"
                @change.native="
                  portfolioManagementRow.internalComments = $event.target.value
                "
                class="internalComments"
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
              </b-input>
            </td>
            <td>
              <b-select
                v-model="portfolioManagementRow.inactiveItem"
                class="inactiveItem"
                :class="
                  loginRole === 6 && isSubmissionActive()
                    ? 'edit-for-ps-inactive-item'
                    : ''
                "
                :value="portfolioManagementRow.inactiveItem"
                :tabindex="portfolioManagementRow.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value="Y">Yes</option>
                <option value="N">No</option>
                >
              </b-select>
            </td>
            <td>
              <ValidationProvider
                v-if="isUser3PPMTab"
                rules="max:11"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="key1"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'key1',
                        portfolioManagementRow.key1
                      )
                    "
                    :value="portfolioManagementRow.key1"
                    @change.native="
                      portfolioManagementRow.key1 = $event.target.value
                    "
                  ></b-input>
                  <b-tooltip
                    label="Keyword 1 maximum length is 11 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.key1 &&
                          portfolioManagementRow.key1.length > 11
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                rules="required|max:11"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="key1"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'key1',
                        portfolioManagementRow.key1
                      )
                    "
                    :value="portfolioManagementRow.key1"
                    @change.native="
                      portfolioManagementRow.key1 = $event.target.value
                    "
                  ></b-input>
                  <b-tooltip
                    label="Keyword 1 maximum length is 11 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.key1 &&
                          portfolioManagementRow.key1.length > 11
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:11"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="key2"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'key2',
                        portfolioManagementRow.key2
                      )
                    "
                    :value="portfolioManagementRow.key2"
                    @change.native="
                      portfolioManagementRow.key2 = $event.target.value
                    "
                  ></b-input>
                  <b-tooltip
                    label="Keyword 2 maximum length is 11 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.key2 &&
                          portfolioManagementRow.key2.length > 11
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:11"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="key3"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'key3',
                        portfolioManagementRow.key3
                      )
                    "
                    :value="portfolioManagementRow.key3"
                    @change.native="
                      portfolioManagementRow.key3 = $event.target.value
                    "
                  ></b-input>
                  <b-tooltip
                    label="Keyword 3 maximum length is 11 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.key3 &&
                          portfolioManagementRow.key3.length > 11
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:11"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="key4"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'key4',
                        portfolioManagementRow.key4
                      )
                    "
                    :value="portfolioManagementRow.key4"
                    @change.native="
                      portfolioManagementRow.key4 = $event.target.value
                    "
                  ></b-input>
                  <b-tooltip
                    label="Keyword 4 maximum length is 11 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.key4 &&
                          portfolioManagementRow.key4.length > 11
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:11"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="key5"
                    v-bind:class="
                      isApiErrorField(
                        portfolioManagementRow.psfsNewItemPMQstnsErrTbs,
                        'key5',
                        portfolioManagementRow.key5
                      )
                    "
                    :value="portfolioManagementRow.key5"
                    @change.native="
                      portfolioManagementRow.key5 = $event.target.value
                    "
                  ></b-input>
                  <b-tooltip
                    label="Keyword 5 maximum length is 11 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="
                        portfolioManagementRow.key5 &&
                          portfolioManagementRow.key5.length > 11
                      "
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import vSelect from "vue-select";
import BSelect from "buefy/src/components/select/Select";
import BInput from "buefy/src/components/input/Input";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

extend("regexUpto4Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,4}$/.test(value)
    };
  },
  computesRequired: true
});

extend("regexUpto2Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,2}$/.test(value)
    };
  },
  computesRequired: true
});

extend("isPcValid", {
  params: ["mcsVal"],
  validate: (value, { mcsVal }) => {
    if (mcsVal && mcsVal.charAt(0) === "A") {
      if (value.startsWith("07")) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
});

//dependency validations for general info tab
extend("valOfAu", {
  params: ["suVal"],
  validate: (value, { suVal }) => {
    if (
      (suVal === "PK" && value === " ") ||
      (suVal === "PK" && value === "CS")
    ) {
      return true;
    } else if (suVal !== "PK") {
      return true;
    }
  }
});

extend("checkValidBasedOnSu", {
  params: ["suVal"],
  validate: (value, { suVal }) => {
    if (suVal === "PK" || suVal === "CS") {
      if (value >= "1" || value >= 1) {
        return true;
      }
    } else {
      return true;
    }
    return false;
  }
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "PortfolioManagementTabComponent.vue",
  components: { BSelect, BInput, vSelect },
  data() {
    return {
      isLoading: false,
      isUser3PPMTab: false,
      selectAllChecked: false,
      checkboxGroup: [],
      selectedRows: [],
      generalQuestionRows: [],
      portfolioManagementRows: [],
      rowIds: [],
      typeAheadTriggered: "",
      paginationParams: [],
      pcOptions: [],
      byrCodeOptions: [],
      cctOptions: [],
      oldMktOptions: [],
      sbuCodeOptions: [],
      taxonomyOptions: [],
      cdcOptions: [],
      mcsCodes: [],
      isFcatNexInSeries: false,
      psToRework: false,
      loginNetworkId: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").networkId
        : "",
      loginNameUser: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").nameUser
        : "",
      loginRole: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").roleKey
        : "",
      portfolioManagementColumns: [
        { label: "Line Errors", col: "lineErrors" },
        { label: "Supplier Catalog Number", col: "vcat" },
        {
          label: "Item Description 30",
          title: "Only allowable special characters are . / \\ -",
          col: "desc30"
        },
        {
          label: "Item Description - 30 Characters(Internal)",
          title: "Only allowable special characters are . / \\ -",
          col: "pmDesc30"
        },
        {
          label: "Item Description - 240 Characters",
          title: "Only allowable special characters are . / \\ - ( ) [ ] %",
          col: "desc240"
        },
        {
          label: "Item Description - 1000 Characters",
          title: "Only allowable special characters are . / \\ - ( ) [ ] %",
          col: "desc1000"
        },
        { label: "Approval Status", col: "indStatus" },
        { label: "Rejection Reason", col: "rejectionReason" },
        { label: "Supplier UOM", col: "suppUom" },
        { label: "Conversion from Supplier to Fisher", col: "suppConv" },
        { label: "Standard Unit", col: "su" },
        { label: "Standard Unit Quantity", col: "suQty" },
        { label: "Standard Unit Cost", col: "suCost" },
        { label: "Standard Unit List", col: "suList" },
        { label: "Discount %", col: "discnt" },
        { label: "Standard Unit Weight", col: "suWt" },
        { label: "Standard Unit Length", col: "suLen" },
        { label: "Standard Unit Width", col: "suWid" },
        { label: "Standard Unit Height", col: "suHt" },
        { label: "Alternate Unit", col: "au" },
        { label: "Alternate Unit Quantity", col: "auQty" },
        { label: "Alternate Unit List", col: "auList" },
        { label: "Alternate Unit Weight", col: "auWt" },
        { label: "Alternate Unit Length", col: "auLen" },
        { label: "Alternate Unit Width", col: "auWid" },
        { label: "Alternate Unit Height", col: "auHt" },
        { label: "Standard Unit List Final", col: "suListFinal" },
        { label: "Alternate Unit List Final", col: "auListFinal" },
        {
          label: "Traditional Marketing Adjustment",
          title:
            "Based on SU Cost. A 1% Marketing Adjustment will automatically be added to franchise parts unless otherwise indicated.",
          col: "tradMa"
        },
        { label: "GTIN - EA", col: "gtinEa" },
        { label: "GTIN - Pack", col: "gtinPk" },
        { label: "GTIN - Case", col: "gtinCs" },
        { label: "UPC - Alternate", col: "upcAlt" },
        { label: "Canada Alternate Unit List", col: "caAuList" },
        {
          label: "Product Code",
          title:
            "item categorization based on item usage and characteristics.  Click here for a list of available codes.",
          className: "pc-header",
          col: "pc"
        },
        {
          label: "Buyer Code",
          title: "the buyer code to be assigned to the product",
          col: "byrCd"
        },
        {
          label: "Vendor Marketing Admin Number (VMA)",
          title:
            "groupings of products within a vendor line; enter the number (found in IMEN10) or indicate if a new VMA is to be created by entering the new description",
          col: "vma"
        },
        {
          label: "Vendor Purchasing Admin Number (VPA)",
          title:
            "Unique number within a vendor; used when purchasing will be done via marketing breakdown.  Use INQVNVPA command in IMPACCT.",
          col: "vpa"
        },
        {
          label: "Strategic Business Unit Code (SBU)",
          title:
            "represents the business unit that has primary responsibility for the product.  Click here for a list of available codes.",
          col: "sbu"
        },
        {
          label: "Customer Discount Category Code (CDC)",
          title:
            "product category discount.  Click here for a list of available codes.",
          col: "cdc"
        },
        {
          label: "Product Family",
          title: "identifies and classifies similar items into families",
          col: "prdFam"
        },
        {
          label: "Product Type",
          title: "Indicates if the product is franchise or third party.",
          col: "prodType"
        },
        {
          label: "Commodity Code Tertiary (CCT)",
          title:
            "a subset of the CCS to futher describe the product.  Click here for a list of available codes.",
          col: "cct"
        },
        {
          label: "Marketing Code Primary (MCP)",
          title:
            "indicates marketing responsibility for the product.  Click here for a list of available codes.",
          col: "mcp"
        },
        {
          label: "Marketing Code Secondary (MCS)",
          title:
            "identifies the product manager responsible for the product.  Click here for a list of available codes.",
          col: "mcs"
        },
        {
          label: "Label Code Primary (LCP)",
          title:
            "product brand designated on the product packaging.  If L or F is selected, then review the Private Label Indicator.  Click here for a list of available codes.",
          col: "lcp"
        },
        {
          label: "Private Label Indicator",
          title:
            "select Fisherbrand supply item (F) or Fisher high list (>$250) product (H)  If selected, then LCP must equal L or F.",
          col: "pvrLbl"
        },
        {
          label: "Research Preferred Code",
          title:
            "preferred products by business unit as determined by marketing, select S, C, or G.",
          col: "rsPrf"
        },
        {
          label: "Healthcare Preferred Code",
          title:
            "preferred products by business unit as determined by marketing, select S, C, or G.",
          col: "hcPrf"
        },
        {
          label: "Safety Preferred Code",
          title:
            "preferred products by business unit as determined by marketing, select S, C, or G.",
          col: "sfPrf"
        },
        {
          label: "Leaf Node",
          className: "leaf-node-header",
          title:
            "The lowest level of the category management taxonomy structure (CMT).  Click here for a list of available codes.",
          col: "taxonomy"
        },
        {
          label: "Serial / Lot Control",
          title:
            "Select S for serial or L for lot if the item has a serial or lot number that requires recording or control",
          col: "serLotPM"
        },
        {
          label: "Ice Charge",
          title: "see instructions for information",
          col: "iceChg"
        },
        {
          label: "Integrity Packaging Fee (IPF)",
          title: "see instructions for information",
          col: "ipf"
        },
        {
          label: "Old Marketing Code",
          title:
            "Marketing code used to categorize products for discounting purposes.  Click here for a list of available codes.",
          col: "oldMkt"
        },
        {
          label: "Direct Ship Indicator",
          title:
            "select shipped direct (D), express shipped direct (E), or not shipped direct (N) for every shipment of this item",
          col: "dirShip"
        },
        { label: "Shelf Life", col: "shlfLf" },
        {
          label: "Shelf Life (Days)",
          title:
            "Shelf life days must be greater than or equal to the source receiving days.",
          col: "shlfLfNum"
        },
        {
          label: "Source Receiving Days",
          title:
            "Source Receiving Days must be greater than or equal to the Source Expiration days.",
          col: "srcRcv"
        },
        { label: "Source Expiration Days", col: "srcExp" },
        {
          label: "Product Class",
          title: "select apparatus A, chemical C",
          col: "prodCls"
        },
        {
          label: "Should this be coded Discount Not Allowed",
          title: "Promo items should be coded as Discount Not Allowed",
          col: "disc"
        },
        {
          label: "Price Type",
          title: "see instructions for information",
          col: "prcType"
        },
        {
          label: "Suggested Fisher Catalog Number Assignment",
          title:
            "Suggested Fisher Catalog Number Assignment maximum length is 11 characters",
          col: "fcatSug"
        },
        {
          label: "Price Book",
          title: "Should the item be added to the next price book?  (Y/N)",
          col: "addPb"
        },
        {
          label: "Authored",
          title: "Should the item be authored in rich-content format? (Y/N)",
          col: "author"
        },
        { label: "Comments", col: "internalComments" },
        { label: "Inactive Item" },
        { label: "Keyword(1)", col: "key1" },
        { label: "Keyword(2)", col: "key2" },
        { label: "Keyword(3)", col: "key3" },
        { label: "Keyword(4)", col: "key4" },
        { label: "Keyword(5)", col: "key5" }
      ]
    };
  },
  props: ["submissionIdForPortfolioManagement", "loadPortfolioManagementData"],
  watch: {
    selectAllChecked: function(isChecked) {
      if (isChecked) {
        this.checkboxGroup = this.rowIds;
      } else {
        this.checkboxGroup = [];
      }
      this.$emit("selectedRowIdsForPortfolioManagement", this.checkboxGroup);
    },
    checkboxGroup: function() {
      this.$emit("selectedRowIdsForPortfolioManagement", this.checkboxGroup);
    },
    loadPortfolioManagementData(value) {
      if (value.loadDetails) {
        value.generalQuestionRows
          ? (this.generalQuestionRows = value.generalQuestionRows)
          : (this.generalQuestionRows = []);
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        if (value.validatePMData) {
          this.renderFromValidateObj(value.validatePMData);
        } else {
          this.loadPortfolioManagementUnderSubmission();
        }
      }
    }
  },
  methods: {
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    addTwoZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 2)
      );
    },
    addFourZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 4)
      );
    },
    addPercentMode(value) {
      return Math.floor(value * 100) + "%";
    },
    loadMcsCodes() {
      var scope = this;
      scope.mcsCodes = [];
      scope.loading = true;
      scope.$http
        .get(`${process.env.VUE_APP_API_BASE_DOMAIN}loadMCSCode`)
        .then(function(response) {
          scope.loading = false;
          scope.mcsCodes = response.data;
          if (scope.isUser3PPMTab) {
            scope.mcsCodes.push("3P");
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.loading = false;
          scope.$buefy.dialog.alert({
            message: `Failed to load MCS codes. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    changeOnPortfolioManagementRow(
      event,
      index,
      rowData,
      portfolioManagementColumns
    ) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("portfolioManagementRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("portfolioManagementRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsNewItemPMQstnsErrTbs" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              rowData.updatedColumnName = key;
              rowData.updatedValue = rowData[key];
              for (let i = 0; i < portfolioManagementColumns.length; i++) {
                if (portfolioManagementColumns[i].col === key)
                  rowData.columnDesc = portfolioManagementColumns[i].label;
              }
              this.updatePortfolioManagementItem(rowData, index);
              break;
            }
          }
        }
      }
    },
    loadPortfolioManagementUnderSubmission() {
      this.checkboxGroup = [];
      this.selectAllChecked = false;
      this.selectedRows = [];
      this.$emit("selectedRowIdsForPortfolioManagement", []);
      (this.pcOptions = []),
        (this.byrCodeOptions = []),
        (this.sbuCodeOptions = []),
        (this.cctOptions = []),
        (this.oldMktOptions = []),
        (this.cdcOptions = []),
        (this.taxonomyOptions = []);
      var portfolioManagementScope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (
        this.actions.fErrors ||
        this.actions.fLineErrors ||
        this.actions.fCat
      ) {
        requestPayload.actions.push("Filter");
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fLineErrors) {
          requestPayload.sortMap.lineErrors = this.actions.fLineErrors;
        }
        if (this.actions.fCat) {
          requestPayload.filterMap.FCAT = this.actions.fCat;
        }
      }
      portfolioManagementScope.isLoading = true;
      portfolioManagementScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}portfolioManagement/submissionId/${portfolioManagementScope.submissionIdForPortfolioManagement}?pageNbr=${portfolioManagementScope.paginationParams.pageIndex}&pageSize=${portfolioManagementScope.paginationParams.numberOfPMItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          portfolioManagementScope.psToRework = window.psToRework;
          document.querySelector("#fcatSugSeries").value === "Next in Series"
            ? (portfolioManagementScope.isFcatNexInSeries = true)
            : (portfolioManagementScope.isFcatNexInSeries = false);
          var pmPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          };
          portfolioManagementScope.$emit(
            "pmPaginationParams",
            pmPaginationParams
          );
          portfolioManagementScope.$emit(
            "pmTabErrorCount",
            response.data.errorCount
          );
          portfolioManagementScope.isLoading = false;
          portfolioManagementScope.isUser3PPMTab = response.data.user3P;
          //loadMcsCodes wrt vn category
          portfolioManagementScope.loadMcsCodes();
          portfolioManagementScope.portfolioManagementRows = [];
          portfolioManagementScope.rowIds = [];

          switch (portfolioManagementScope.loginRole) {
            case 1:
              portfolioManagementScope.$emit("enablePMApproverSubmit", true);
              break;
            case 2:
              if (
                response.data.errorCount === 0 &&
                document.querySelectorAll(
                  ".portfolio-management-submission-level-div .invalid"
                ).length === 0
              ) {
                //enable submit button
                portfolioManagementScope.$emit("enablePMApproverSubmit", true);
              } else {
                //disable submit button
                portfolioManagementScope.$emit("disablePMApproverSubmit", true);
              }
              break;
            case 6:
              //emit errorCount for super user when isSubmissionActiveForPS is true
              if (window.isSubmissionActiveForPS) {
                portfolioManagementScope.$emit(
                  "pmErrorCountForSuperUser",
                  response.data.errorCount
                );
              }
              break;
          }
          //for role 1
          if (portfolioManagementScope.loginRole === 1) {
            portfolioManagementScope.$emit(
              "errorCountOnPSUpdate",
              response.data.errorCount
            );
          }
          var mutableResponseRows = response.data.psfsNewItemPMQstnsTbs;
          if (requestPayload.actions.length > 0) {
            if (response.data.psfsNewItemPMQstnsTbs.length > 0) {
              for (
                var i = 0, lineNumber = pmPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                if (
                  !(
                    (portfolioManagementScope.psToRework &&
                      mutableResponseRows[i].rejectedBy !==
                        portfolioManagementScope.loginNetworkId &&
                      (mutableResponseRows[i].apprvlStatus === "R" ||
                        mutableResponseRows[i].indStatus === "Rejected")) ||
                    (mutableResponseRows[i].rejectedBy !==
                      portfolioManagementScope.loginNetworkId &&
                      mutableResponseRows[i].rejectedByRole > 2 &&
                      (mutableResponseRows[i].apprvlStatus === "R" ||
                        mutableResponseRows[i].indStatus === "Rejected")) ||
                    (mutableResponseRows[i].rejectedBy !==
                      portfolioManagementScope.loginNetworkId &&
                      mutableResponseRows[i].rejectedBy === "CAS" &&
                      (mutableResponseRows[i].apprvlStatus === "R" ||
                        mutableResponseRows[i].indStatus === "Rejected"))
                  )
                ) {
                  portfolioManagementScope.rowIds.push(
                    mutableResponseRows[i].genlQstnId
                  );
                }
                mutableResponseRows[i].lineNumber = lineNumber;
              }
              portfolioManagementScope.portfolioManagementRows = mutableResponseRows;
              sessionStorage.setItem(
                "portfolioManagementRows",
                JSON.stringify(response.data.psfsNewItemPMQstnsTbs)
              );
            } else {
              portfolioManagementScope.portfolioManagementRows = [];
            }
          } else {
            if (response.data.psfsNewItemPMQstnsTbs.length > 0) {
              for (
                var j = 0, lineNumberJ = pmPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                if (
                  !(
                    (portfolioManagementScope.psToRework &&
                      mutableResponseRows[j].rejectedBy !==
                        portfolioManagementScope.loginNetworkId &&
                      (mutableResponseRows[j].apprvlStatus === "R" ||
                        mutableResponseRows[j].indStatus === "Rejected")) ||
                    (mutableResponseRows[j].rejectedBy !==
                      portfolioManagementScope.loginNetworkId &&
                      mutableResponseRows[j].rejectedByRole > 2 &&
                      (mutableResponseRows[j].apprvlStatus === "R" ||
                        mutableResponseRows[j].indStatus === "Rejected")) ||
                    (mutableResponseRows[j].rejectedBy !==
                      portfolioManagementScope.loginNetworkId &&
                      mutableResponseRows[j].rejectedBy === "CAS" &&
                      (mutableResponseRows[j].apprvlStatus === "R" ||
                        mutableResponseRows[j].indStatus === "Rejected"))
                  )
                ) {
                  portfolioManagementScope.rowIds.push(
                    mutableResponseRows[j].genlQstnId
                  );
                }
                mutableResponseRows[j].lineNumber = lineNumberJ;
              }
              portfolioManagementScope.portfolioManagementRows = mutableResponseRows;
              sessionStorage.setItem(
                "portfolioManagementRows",
                JSON.stringify(response.data.psfsNewItemPMQstnsTbs)
              );
            } else {
              portfolioManagementScope.portfolioManagementRows = [];
              sessionStorage.removeItem("portfolioManagementRows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          portfolioManagementScope.isLoading = false;
          portfolioManagementScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${portfolioManagementScope.submissionIdForPortfolioManagement}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          //focus on first editable pmDesc30 field
          if (!$(".ni-app-portfolio-management-tab").hasClass("viewOnly")) {
            var firstEditableCell = $(".ni-app-portfolio-management-tbody")
              .children("tr:not(.lock-row)")
              .first();
            if (firstEditableCell.hasClass("lock-partial-row")) {
              firstEditableCell
                .find("td:has(.apprvlStatus select)")
                .find("select")
                .focus();
            } else {
              firstEditableCell
                .find("td:has(.pmDesc30 input)")
                .find("input")
                .focus();
            }
          }

          //custom navigator plugin using jquery
          (function($) {
            $.fn.enableCellNavigation = function() {
              var arrow = {
                left: 37,
                up: 38,
                right: 39,
                down: 40
              };
              var esc = 27;

              // select all on focus
              // works for elements and will put focus into
              // adjacent input or select
              this.find("input,select").keydown(function(e) {
                // shortcut for key other than arrow keys
                if (
                  $.inArray(e.which, [
                    arrow.left,
                    arrow.up,
                    arrow.right,
                    arrow.down,
                    esc
                  ]) < 0
                ) {
                  return;
                }

                var input = e.target;
                var td = $(e.target).closest("td");
                var moveTo = null;

                switch (e.which) {
                  case arrow.left: {
                    if (
                      ($(input).is("input:text") &&
                        input.selectionStart !== 0) === false
                    ) {
                      //left key on checkbox
                      if (td.index() === 2) {
                        //go to rejection reason if lock-partial-row
                        if (
                          td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row)")
                            .first()
                            .hasClass("lock-partial-row")
                        ) {
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row)")
                            .first("tr")
                            .find("td:has(.rejectionReason input)");
                        } else {
                          //else go to previous row interalComments
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row):not(.lock-partial-row)")
                            .first("tr")
                            .find("td:has(.key5 input)");
                        }
                      }
                      //if left on pmDesc30
                      else if (td.index() === 6) {
                        moveTo = td.prevAll("td:has(input:checkbox)");
                      }
                      //if left on status
                      else if (td.index() === 9) {
                        //go to checkbox if lock-partial-row
                        if (td.parents("tr").hasClass("lock-partial-row")) {
                          moveTo = td.prevAll("td:has(input:checkbox)");
                        } else {
                          //else go to prev input
                          moveTo = td.prev("td:has(input)");
                        }
                      }
                      //left on input, select
                      else {
                        //if current filed disabled go to prev input, select that are not disabled
                        if (td.prev("td:has(input,select)").has(":disabled")) {
                          moveTo = td.prevAll(
                            "td:has(input:not(:disabled),select:not(:disabled))"
                          );
                        } else {
                          //go to prev input, select
                          moveTo = td.prev("td:has(input,select)");
                        }
                      }
                    }
                    break;
                  }
                  case arrow.right: {
                    if (
                      ($(input).is("input:text") &&
                        input.selectionStart !== input.value.length) === false
                    ) {
                      //right on checkbox
                      if (td.index() === 2) {
                        //go to status if lock-partial-row
                        if (td.parents("tr").hasClass("lock-partial-row")) {
                          moveTo = td.nextAll("td:has(.apprvlStatus select)");
                        } else {
                          //else go to pmDesc30 input
                          moveTo = td.nextAll("td:has(.pmDesc30 input)");
                        }
                      }
                      //right on status
                      else if (td.index() === 9) {
                        //go to rejectionReason if lock-partial-row
                        if (td.parents("tr").hasClass("lock-partial-row")) {
                          moveTo = td.next("td:has(.rejectionReason input)");
                        } else {
                          //else go to suppUom select
                          moveTo = td.nextAll("td:has(.suppUom select)");
                        }
                      }
                      //right on rejectionReason
                      else if (td.index() === 10) {
                        moveTo = td
                          .parents("tr")
                          .nextAll("tr:not(.lock-row)")
                          .find("td:has(input:checkbox)");
                      }
                      //right on last field on row
                      else if (td.index() === 75) {
                        //go to input on next row that is not lock-row
                        moveTo = td
                          .parents("tr")
                          .nextAll("tr:not(.lock-row)")
                          .find("td:has(input:checkbox)");
                      }
                      //right on input, select
                      else {
                        //if current filed disabled go to prev input, select that are not disabled
                        if (td.next("td:has(input,select)").has(":disabled")) {
                          moveTo = td.nextAll(
                            "td:has(input:not(:disabled),select:not(:disabled))"
                          );
                        }
                        //go to next input, select
                        else {
                          moveTo = td.next("td:has(input,select)");
                        }
                      }
                    }
                    break;
                  }

                  case arrow.up:
                  case arrow.down: {
                    e.preventDefault();
                    var tr = td.closest("tr");
                    var pos = td.index();

                    var moveToRow = null;
                    //skip over rejected rows on up/down
                    if (e.which == arrow.down) {
                      moveToRow = tr.nextAll(
                        "tr:not(.lock-partial-row):not(.lock-row)"
                      );
                    } else if (e.which == arrow.up) {
                      moveToRow = tr.prevAll(
                        "tr:not(.lock-partial-row):not(.lock-row)"
                      );
                    }

                    if (moveToRow.length) {
                      moveTo = $(moveToRow[0].children[0].children[pos]);
                    }
                    break;
                  }
                  case esc:
                    if (e.target.localName === "select") {
                      console.log("esc clicked on select");
                    }
                    break;
                }

                if (moveTo && moveTo.length) {
                  e.preventDefault();
                  var input = $(moveTo[0]).find("input")[0];
                  if (arrow.right === e.which && $(input).is("input:text")) {
                    // var input = $(moveTo[0]).find("input")[0];
                    input.focus();
                    $(input)
                      .get(0)
                      .setSelectionRange(0, 0);
                  } else if (
                    arrow.left === e.which &&
                    $(input).is("input:text")
                  ) {
                    // var input = $(moveTo[0]).find("input")[0];
                    if (typeof input.selectionStart == "number") {
                      input.selectionStart = input.selectionEnd =
                        input.value.length;
                    } else if (typeof input.createTextRange != "undefined") {
                      var range = input.createTextRange();
                      range.collapse(false);
                      range.select();
                    }
                    input.focus();
                  } else if ($(input).is("input:text")) {
                    // var input = $(moveTo[0]).find("input")[0];
                    input.focus();
                  } else {
                    //focus on input, select
                    var input = $(moveTo[0]).find("input,select")[0];
                    input.focus();
                  }
                }
              });
            };
          })($);

          // use the plugin
          $(function() {
            $("#ni-portfolio-management-table").enableCellNavigation();
          });
        });
    },
    renderFromValidateObj(data) {
      var portfolioManagementScope = this;
      document.querySelector("#fcatSugSeries").value === "Next in Series"
        ? (portfolioManagementScope.isFcatNexInSeries = true)
        : (portfolioManagementScope.isFcatNexInSeries = false);
      var pmPaginationParams = {
        startIndex: data.startIndex,
        endIndex: data.endIndex,
        totalCount: data.totalCount,
        totalPages: data.totalPages
      };
      portfolioManagementScope.$emit("pmPaginationParams", pmPaginationParams);
      portfolioManagementScope.$emit("pmTabErrorCount", data.errorCount);
      portfolioManagementScope.isLoading = false;
      portfolioManagementScope.isUser3PPMTab = data.user3P;
      //loadMcsCodes wrt vn category
      portfolioManagementScope.loadMcsCodes();
      portfolioManagementScope.portfolioManagementRows = [];
      portfolioManagementScope.rowIds = [];

      switch (portfolioManagementScope.loginRole) {
        case 1:
          portfolioManagementScope.$emit("enablePMApproverSubmit", true);
          break;
        case 2:
          if (
            data.errorCount === 0 &&
            document.querySelectorAll(
              ".portfolio-management-submission-level-div .invalid"
            ).length === 0
          ) {
            //enable submit button
            portfolioManagementScope.$emit("enablePMApproverSubmit", true);
          } else {
            //disable submit button
            portfolioManagementScope.$emit("disablePMApproverSubmit", true);
          }
          break;
        case 6:
          //emit errorCount for super user when isSubmissionActiveForPS is true
          if (window.isSubmissionActiveForPS) {
            portfolioManagementScope.$emit(
              "pmErrorCountForSuperUser",
              data.errorCount
            );
          }
          break;
      }
      //for role 1
      if (portfolioManagementScope.loginRole === 1) {
        portfolioManagementScope.$emit("errorCountOnPSUpdate", data.errorCount);
      }
      var mutableResponseRows = data.psfsNewItemPMQstnsTbs;
      if (data.psfsNewItemPMQstnsTbs.length > 0) {
        for (
          var i = 0, lineNumber = pmPaginationParams.startIndex;
          i < mutableResponseRows.length && lineNumber > 0;
          i++, lineNumber++
        ) {
          if (
            !(
              (portfolioManagementScope.psToRework &&
                mutableResponseRows[i].rejectedBy !==
                  portfolioManagementScope.loginNetworkId &&
                (mutableResponseRows[i].apprvlStatus === "R" ||
                  mutableResponseRows[i].indStatus === "Rejected")) ||
              (mutableResponseRows[i].rejectedBy !==
                portfolioManagementScope.loginNetworkId &&
                mutableResponseRows[i].rejectedByRole > 2 &&
                (mutableResponseRows[i].apprvlStatus === "R" ||
                  mutableResponseRows[i].indStatus === "Rejected")) ||
              (mutableResponseRows[i].rejectedBy !==
                portfolioManagementScope.loginNetworkId &&
                mutableResponseRows[i].rejectedBy === "CAS" &&
                (mutableResponseRows[i].apprvlStatus === "R" ||
                  mutableResponseRows[i].indStatus === "Rejected"))
            )
          ) {
            portfolioManagementScope.rowIds.push(
              mutableResponseRows[i].genlQstnId
            );
          }
          mutableResponseRows[i].lineNumber = lineNumber;
        }
        portfolioManagementScope.portfolioManagementRows = mutableResponseRows;
        sessionStorage.setItem(
          "portfolioManagementRows",
          JSON.stringify(data.psfsNewItemPMQstnsTbs)
        );
      } else {
        portfolioManagementScope.portfolioManagementRows = [];
      }
    },
    updatePortfolioManagementItem(requestPayload, index) {
      var portfolioManagementScope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var updatedRowData = {};
      var approverNetworkId = portfolioManagementScope.loginNetworkId;
      requestPayload.updatedBy = portfolioManagementScope.loginNameUser;
      /*      requestPayload.indStatus === "Rejected"
        ? (requestPayload.updatedBy = approverNetworkId)
        : "";*/

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if ((key === "mcs" && prop === "") || prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      portfolioManagementScope.isLoading = true;
      portfolioManagementScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}updatePortfolioManagement/submissionId/${portfolioManagementScope.submissionIdForPortfolioManagement}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          portfolioManagementScope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber =
            portfolioManagementScope.portfolioManagementRows[index].lineNumber;
          portfolioManagementScope.portfolioManagementRows[index] = apiRow;
          var pmRows = JSON.parse(
            sessionStorage.getItem("portfolioManagementRows")
          );
          pmRows.splice(index, 1, response.data);
          sessionStorage.setItem(
            "portfolioManagementRows",
            JSON.stringify(pmRows)
          );
          //enable/disable submit button
          switch (portfolioManagementScope.loginRole) {
            case 1:
              portfolioManagementScope.$emit("enablePMApproverSubmit", true);
              break;
            case 2:
              if (
                response.data.totalErrorCount === 0 &&
                document.querySelectorAll(
                  ".portfolio-management-submission-level-div .invalid"
                ).length === 0
              ) {
                //enable submit button
                portfolioManagementScope.$emit("enablePMApproverSubmit", true);
              } else {
                //disable submit button
                portfolioManagementScope.$emit("disablePMApproverSubmit", true);
              }
              break;
            case 6:
              //emit errorCount for super user when isSubmissionActiveForPS is true
              if (window.isSubmissionActiveForPS) {
                portfolioManagementScope.$emit(
                  "pmErrorCountForSuperUser",
                  response.data.totalErrorCount
                );
              }
              break;
          }
          portfolioManagementScope.$emit(
            "pmTabErrorCount",
            response.data.totalErrorCount
          );
          //for update made by role 1
          if (portfolioManagementScope.loginRole === 1) {
            portfolioManagementScope.$emit(
              "errorCountOnPSUpdate",
              response.data.totalErrorCount
            );
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          portfolioManagementScope.isLoading = false;
          portfolioManagementScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${portfolioManagementScope.submissionIdForPortfolioManagement}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(
            ".ni-app-portfolio-management-tbody"
          ).rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".ni-app-portfolio-management-tbody")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    disableOnDisc(portfolioManagementRow) {
      if (portfolioManagementRow.disc === "Y") {
        return true;
      } else {
        return false;
      }
    },
    disableOnRule(portfolioManagementRow) {
      if (portfolioManagementRow.serLotPM === "L") {
        return true;
      } else {
        return false;
      }
    },
    disableOnStatus(portfolioManagementRow) {
      if (portfolioManagementRow.indStatus === "Rejected") {
        return false;
      } else {
        return true;
      }
    },
    fetchTypeAhead(search, loading) {
      if (search.length > 0) {
        var portfolioManagementScope = this;
        var url = "";

        switch (portfolioManagementScope.typeAheadTriggered) {
          case "pc":
            url = "loadPcCodes";
            break;
          case "byrCode":
            url = "loadByrCodes";
            break;
          case "cct":
            url = "loadCctCodes";
            break;
          case "oldMkt":
            url = "loadOldMktCodes";
            break;
          case "sbu":
            url = "loadSbuCodes";
            break;
          case "taxonomy":
            url = "loadTaxonomyCodes";
            break;
          case "cdc":
            url = "loadCdcCodes";
            break;
        }

        loading(true);
        portfolioManagementScope.$http
          .get(`${process.env.VUE_APP_API_BASE_DOMAIN}${url}/${search}`)
          .then(function(response) {
            loading(false);
            switch (portfolioManagementScope.typeAheadTriggered) {
              case "pc":
                portfolioManagementScope.pcOptions = response.data;
                break;
              case "byrCode":
                portfolioManagementScope.byrCodeOptions = response.data;
                break;
              case "cct":
                portfolioManagementScope.cctOptions = response.data;
                break;
              case "oldMkt":
                portfolioManagementScope.oldMktOptions = response.data;
                break;
              case "sbu":
                portfolioManagementScope.sbuCodeOptions = response.data;
                break;
              case "taxonomy":
                portfolioManagementScope.taxonomyOptions = response.data;
                break;
              case "cdc":
                portfolioManagementScope.cdcOptions = response.data;
                break;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            portfolioManagementScope.$buefy.dialog.alert({
              message: `Failed to load matching results. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    updateSuDependentValues(rowData) {
      if (rowData.su === "EA" || rowData.su === "PR") {
        rowData.suQty = "1";
      } else if (rowData.su === "DZ") {
        rowData.suQty = "12";
      }
      // this.disableSuQty();
      return rowData;
    },
    updateAuDependentValues(rowData) {
      if (rowData.au === "DZ") {
        rowData.auQty = "12";
      }
      return rowData;
    },
    disableBasedOnSu(suVal) {
      if (suVal === "EA" || suVal === "PR" || suVal === "DZ") {
        return true;
      } else {
        return false;
      }
    },
    disableAuQtyIf(suVal, auVal) {
      if (
        suVal === "CS" ||
        auVal === "DZ" ||
        auVal.trim() === "" ||
        auVal === undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    disableOnDiscNo(disc) {
      if (disc === "N") {
        return true;
      } else {
        return false;
      }
    },
    calculateDiscount(rowData) {
      if (rowData.suList && rowData.suCost) {
        rowData.discnt = (
          (rowData.suList - rowData.suCost) /
          rowData.suList
        ).toFixed(2);
      }
      return rowData;
    },
    // eslint-disable-next-line no-unused-vars
    isApiErrorField(errorFieldNames, className, value) {
      if (errorFieldNames && errorFieldNames.length > 0) {
        for (var i = 0; i < errorFieldNames.length; i++) {
          if (
            errorFieldNames[i].columnName.replace(/_/g, "").toLowerCase() ===
            className.toLowerCase()
          ) {
            return "is-danger";
          }
        }
      } else {
        return "";
      }
    },
    isSuListFinalValueValid(rowData) {
      var calculatedCost = rowData.suCost + rowData.tradMa;
      if (
        rowData.suListFinal < rowData.suCost ||
        rowData.suListFinal < calculatedCost
      ) {
        return "invalid";
      }
    },
    isAuListFinalValueValid(rowData) {
      var auCost = rowData.suCost * rowData.auQty,
        calculatedCost = (rowData.suCost + rowData.tradMa) * rowData.auQty;
      if (
        rowData.auListFinal < auCost ||
        rowData.auListFinal < calculatedCost
      ) {
        return "is-danger";
      }
    },
    isSubmissionActive() {
      var productServicesClassList = document.querySelector(
        ".ni-app-product-services-tab"
      ).classList;
      if (
        productServicesClassList[productServicesClassList.length - 1] ===
        "status-active"
      ) {
        return true;
      }
    }
  }
};
</script>

<style scoped></style>
